module.exports = __webpack_public_path__ + "static/img/dzp2.7cfc0c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp2.jpg
// module id = +unm
// module chunks = 1